import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    host: {
    class: 'theme-dark',
  },
  selector: 'app-device-settings-audio-circles',
    standalone: true,
  imports: [CommonModule],
  templateUrl: './device-settings-audio-circles.component.html',
  styleUrls: ['./device-settings-audio-circles.component.scss']
})
export class DeviceSettingsAudioCirclesComponent {
  @Input() decibels?: number;
  @Input() levels = 12;
  @Input() minThreshold = -22;

  get thresholds() {
    const thresholds: number[] = [];
    for (let i = 0; i < this.levels; i++) {
      thresholds.push(this.minThreshold + i);
    }
    return thresholds;
  }
}
